/* global jQuery */
/* global lity */


export default class Graella {

	constructor(el, laberint, api) {
		this.el = el;
		this.laberint = laberint;
		this.api = api;

		this.el.innerHTML = "";
		this.create_container();
		this.create_cells();
	}

	create_container() {
		this.container = document.createElement('div');
		this.container.classList.add('laberint');
		this.container.style.gridTemplateColumns = '0.3fr repeat(' + this.laberint.wlx + ', 1fr) 0.3fr';
		this.container.style.gridTemplateRows = '0.3fr repeat(' + this.laberint.wly + ', 1fr) 0.3fr';
		this.el.appendChild(this.container);
	}

	check_wall(arr, i, j) {
		if ((i >= 0) && (i < arr.length ) && (j >= 0) && (j < arr[i].length)) {
			return arr[i][j] > 0;
		}

		return false;
	}

	create_cell(i, j) {
		const cell = document.createElement('div');
		cell.classList.add('cela');

		if (this.check_wall(this.laberint.arrv, i, j)) {
			cell.classList.add('paret-esquerra');
		}
		if (this.check_wall(this.laberint.arrv, i + 1, j)) {
			cell.classList.add('paret-dreta');
		}
		if (this.check_wall(this.laberint.arrh, i, j)) {
			cell.classList.add('paret-dalt');
		}
		if (this.check_wall(this.laberint.arrh, i, j + 1)) {
			cell.classList.add('paret-baix');
		}

		return cell;
	}

	create_cell_link(futur, i, j) {
		const self = this;

		const a = document.createElement('a');
		a.href = futur.permalink;
		a.target = '_blank';
		a.innerHTML = futur.title;
		jQuery(a).on('click', function (e) {
			e.preventDefault();

			const movements = [];

			if ((i === 0) && (! self.laberint.arrv[i][j])) {
				movements.push('left')
			} else if ((i === self.laberint.wlx - 1) && (! self.laberint.arrv[i+1][j])) {
				movements.push('right')
			}

			if ((j === 0) && (! self.laberint.arrh[i][j])) {
				movements.push('up')
			} else if ((j === self.laberint.wly - 1) && (! self.laberint.arrh[i][j+1])) {
				movements.push('down')
			}

			self.api.visita(futur.id);

			const lightbox_link = futur.permalink + "?lightbox=true"
			lity(lightbox_link);

			const movement = movements[Math.floor(Math.random() * movements.length)];
			const movement_method = "move_" + movement;
			self.api[movement_method]();
		});
		return a;
	}

	inside_laberint(i, j) {
		return ((i >= 0) && (i < this.laberint.wlx) && (j >= 0) && (j < this.laberint.wly));
	}

	create_cells() {
		const numEndCells = this.laberint.endCells.size;
		const selected_futurs = this.api.continguts.get(this.laberint.x, this.laberint.y, numEndCells, this.api.x, this.api.y);

		for(let j=-1; j<=this.laberint.wly; j++) {
			for(let i=-1; i<=this.laberint.wlx; i++) {
				const cell = this.create_cell(i, j);
				if (this.inside_laberint(i, j)) {
					if (this.laberint.endCellsArr[i][j]) {
						const selected_futur = selected_futurs.pop();
						const cell_link = this.create_cell_link(selected_futur, i, j);
						cell.appendChild(cell_link);
					}
				} else {
					if (this.inside_laberint(i-1, j) && ! this.laberint.arrv[i][j]) {
						cell.innerHTML = "&rarr;";
						cell.classList.add("arrow");
						cell.addEventListener("click", () => { this.api.move_right(); })
					} else if (this.inside_laberint(i+1, j) && ! this.laberint.arrv[i+1][j]) {
						cell.innerHTML = "&larr;";
						cell.classList.add("arrow");
						cell.addEventListener("click", () => { this.api.move_left(); })
					} else if (this.inside_laberint(i, j-1) && ! this.laberint.arrh[i][j]) {
						cell.innerHTML = "&rarr;";
						cell.classList.add("arrow");
						cell.classList.add("rotate");
						cell.addEventListener("click", () => { this.api.move_down(); })
					} else if (this.inside_laberint(i, j+1) && ! this.laberint.arrh[i][j+1]) {
						cell.innerHTML = "&larr;";
						cell.classList.add("arrow");
						cell.classList.add("rotate");
						cell.addEventListener("click", () => { this.api.move_up(); })
					}
				}
				this.container.appendChild(cell);
			}
		}
	}

}
